import { render } from "./vprintresourcesadd.vue?vue&type=template&id=58091c08&scoped=true"
import script from "./vprintresourcesadd.vue?vue&type=script&lang=js"
export * from "./vprintresourcesadd.vue?vue&type=script&lang=js"

import "./vprintresourcesadd.vue?vue&type=style&index=0&id=58091c08&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58091c08"]])

export default __exports__